import { useDispatch, useSelector } from "react-redux";
import { Switch } from "@mui/material";
import { actions } from "app/configSlice";
import { updateParentConfig } from "app/api";
import { RootState, AppDispatch } from "app/store";
import i18n from "features/shared/i18n";

/**
 * 端末を振ってバグ報告を出す機能のオン/オフ。
 * 振る操作を検知できるのはアプリの中だけなので、web では設定自体を出さない。
 */
export const ShakeSettingSection = () => {
  const dispatch = useDispatch<AppDispatch>();
  const parent = useSelector((state: RootState) => state.user.parent);
  const shakeBugReport = useSelector(
    (state: RootState) => state.config.parentConfig.shake_bug_report,
  );

  const handleToggle = (_: unknown, checked: boolean) => {
    dispatch(actions.updateParentConfig({ key: "shake_bug_report", value: checked }));
    if (parent?.uid) dispatch(updateParentConfig({ uid: parent.uid }));
  };

  if (!window.ReactNativeWebView) return null;

  return (
    <div className="bg-white rounded-[16px] p-6">
      <div className="flex-row-el items-center gap-2 text-[27px] text-textcolor-black mb-5 pb-3 border-b border-outline">
        <span className="material-symbols-outlined !text-[45px] text-red-100">bug_report</span>
        {i18n.t("MSG_PARENTS_SHAKE_SETTING_SECTION_TITLE")}
      </div>

      {/* 説明を同じ行に入れるとスイッチが 2 行の上下中央に寄って間延びするので、
          ラベルとスイッチを同じ行に置き、説明はその下に出す */}
      <div className="flex-row-el items-center justify-between gap-4 w-full">
        <p className="text-[24px] text-textcolor-black">
          {i18n.t("MSG_PARENTS_SHAKE_BUG_REPORT_TOGGLE_LABEL")}
        </p>
        <Switch
          checked={!!shakeBugReport}
          onChange={handleToggle}
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": { color: "#4c9df1" },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "#4c9df1",
            },
          }}
        />
      </div>
      <p className="text-[20px] text-gray2-100">
        {i18n.t("MSG_PARENTS_SHAKE_BUG_REPORT_TOGGLE_DESCRIPTION")}
      </p>
    </div>
  );
};
